<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('groups.link_groups')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div ref="selectRef">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('groups.header')}}</label>
              <el-form-item prop="groupId">
                <base-el-select ref="groupsSelector" class="w-full" :groups="listaGroupsGrouping" v-model="form.groupId" multiple filterable :disabled="isLoadingSelect" :optionKey="getGroupId"
                  @visible-change="onExpand" @change="onChangeInput" @select-all="onSelectAll" @unselect-all="onUnselectAll" />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
        <base-button mode="secondary-phantom-blue"
            class="w-full"
          v-if="!isAllSelected" 
          :disabled="!isLoadedData || isLoadingSelect || isEmptyList" 
          :text="$t('app.select_all')" 
          @click="$refs.groupsSelector.selectAll()" 
          :loading="isLoadingSelect"
          />
        <base-button v-else :text="$t('app.unselect_all')" mode="secondary-phantom-blue"
            class="w-full"
          @click="$refs.groupsSelector.unselectAll()"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect || isEmptyList"
          />
          <div class="w-48 "></div>
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
            class="w-full"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
        <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply" 
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
    </template>
  </base-dialog-button>
</template>

<script>
import { i18n } from '@/i18n'
import { getGroupsSimple } from '@/services/configurations/groups/getGroupsSimple'

export default
{
  name: 'user-link-groups-dialog',
  components: {
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        groupId: []
      },
      groups: [],
      isLoadedData: false,
      loadingActionSelect: false,
      loadingActionUnSelect: false
    }
  },
  mounted: async function () {
    this.isLoadedData = false
    const data = await getGroupsSimple({ idUsuario: this.$route.params.id })
    if (data.blnError === true) {
      this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
    } else {
      data.Respuesta.forEach(row => {
        this.groups.push(row)
      })
    }
    this.isLoadedData = true
  },
  watch: {
    dialogOpen: function (value, oldValue) {
      if (value !== oldValue) {
        this.isOpen = value
        this.heightSelect = 0
      }
    }
  },
  computed: {
    tiposGrupo: function () {
      return this.$store.getters['config/TIPOS_GRUPO']
    },
    listaGroupsGrouping () {
      const groupTypes = this.tiposGrupo.reduce((acc, x) => ({ ...acc, [x.id]: x }), {})
      return this.groups.reduce((a, b) => ({ ...a, [groupTypes[b.idTipo]?.name]: [...(a[groupTypes[b.idTipo]?.name] || []), b] }), {})
    },
    isEmptyList: function () {
      return this.groups === undefined || this.groups === null || this.groups.length === 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    isAllSelected: function () {
      if (this.groups.length === this.form.groupId.length) return true
      else return false
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
  },
  methods: {
    getGroupId: function (option) {
      return option.IdGrupo
    },
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight ?? 0
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRef?.clientHeight ?? 0
      }, 100)
    },
    onSelectAll: function (loading) {
      this.loadingActionSelect = loading
    },
    onUnselectAll: function (loading) {
      this.loadingActionUnSelect = loading
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.form.groupId = []
    },
    apply: function () {
      this.isOpen = !this.isOpen
      this.$emit('applyDialog', this.form.groupId)
      this.form.groupId = []
    },
  }
}
</script>

<style lang="scss" scoped></style>
